import TwilioRoom from '@components/twilio-room';
import { showNotification } from '@helpers/notification-helper';
import Button from '@hilbi/web-common/components/button';
import { actions as eVisitAction } from '@store/ducks/e-visits';
import { actions } from '@store/ducks/twilio';
import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EVisitItem, ITagSettingsItem } from 'types/e-visits';
import TStore from 'types/store';
import { CommunicationAreaSC } from './communication-area.styled';

interface CommunicationAreaProps {
  item: EVisitItem;
}

export const CommunicationArea: React.FunctionComponent<CommunicationAreaProps> = ({ item }) => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const { formatMessage } = useIntl();

  // @ts-expect-error wrong types
  const patientProfile = item.event.extraData?.client;

  const twilioErrorMessage = useSelector((state: TStore) => state.twilio.twilioErrorMessage);
  const reqStatus = useSelector((state: TStore) => state.twilio.joinTwilioRoomRequestStatus);

  useEffect(() => {
    if (twilioErrorMessage) {
      dispatch(actions.setErrorMessage(''));
      showNotification({
        type: 'ERROR',
        title: formatMessage({
          id: twilioErrorMessage,
        }),
        copy: '',
      });
    }
  }, [twilioErrorMessage, dispatch]);

  const communicationType: ITagSettingsItem | null = useMemo(() => {
    if (!item || !item.order?.tag?.settings || item.order.tag.settings.length === 0) {
      return null;
    } else {
      return item.order.tag.settings[0];
    }
  }, [item]);

  if (!communicationType) {
    return null;
  }

  const handleJoinClick = () => {
    if (patientProfile?.pairing?.status === 'paired') {
      dispatch(eVisitAction.setSingleEvent(item));
      push(`/life-id/${patientProfile.id}`);
    } else {
      dispatch(
        actions.joinTwilioRoomRequest({
          orderId: item.order?.id as string,
        }),
      );
    }
  };

  return (
    <CommunicationAreaSC>
      {item.order?.tag?.settings && item.order?.tag?.settings[0] === 'videocall' ? (
        <Button onClick={() => handleJoinClick()}>
          {formatMessage({
            id: communicationType === 'chat' ? 'eVisits_chat' : 'eVisits_videoCall',
          })}
        </Button>
      ) : (
        ''
      )}
      {reqStatus === 'success' ? <TwilioRoom item={item} /> : null}
    </CommunicationAreaSC>
  );
};

export default React.memo(CommunicationArea);
